(function(){
/* ==========================================================
   CARUSEL DE PRODUSE — pas de un card, glisare cu degetul
   și cu mouse-ul, autoplay oprit la interacțiune
   ========================================================== */
function per(c){
  var cell=c.querySelector('.rx-carousel__cell'),view=c.querySelector('.rx-carousel__view');
  if(cell&&view){
    var cw=cell.getBoundingClientRect().width,vw=view.getBoundingClientRect().width;
    if(cw>0&&vw>0)return Math.max(1,Math.round(vw/cw));
  }
  var w=window.innerWidth,d=parseInt(c.getAttribute('data-per')||'4',10);
  if(w<=640)return 2;if(w<=1000)return 2;return d;
}
function init(c){
  if(c.dataset.rxInit)return;c.dataset.rxInit='1';
  var view=c.querySelector('.rx-carousel__view');
  var track=c.querySelector('.rx-carousel__track');if(!track||!view)return;
  var cells=track.querySelectorAll('.rx-carousel__cell');if(!cells.length)return;
  var prev=c.querySelector('.rx-carousel__nav--prev'),next=c.querySelector('.rx-carousel__nav--next'),dots=c.querySelector('.rx-carousel__dots');
  var i=0,drag=false,startX=0,startY=0,dx=0,base=0,locked=null;

  function step(){return cells[0].getBoundingClientRect().width}
  function maxIndex(){return Math.max(0,cells.length-per(c))}
  function pos(idx){return -idx*step()}

  function apply(px,anim){
    track.style.transition=anim?'transform .45s var(--ease)':'none';
    track.style.transform='translate3d('+px+'px,0,0)';
  }
  function render(anim){
    var max=maxIndex();if(i>max)i=max;if(i<0)i=0;
    apply(pos(i),anim!==false);
    if(prev)prev.disabled=(i===0);
    if(next)next.disabled=(i>=max);
    if(dots){
      dots.innerHTML='';
      if(max>0){for(var k=0;k<=max;k++){(function(k){
        var b=document.createElement('button');
        b.type='button';b.setAttribute('aria-label','Cardul '+(k+1));
        if(k===i)b.className='is-on';
        b.onclick=function(){stop();i=k;render()};
        dots.appendChild(b);
      })(k)}}
    }
  }

  /* autoplay — doar dacă secțiunea o cere */
  var auto=null,delay=parseInt(c.getAttribute('data-autoplay')||'0',10);
  function play(){if(!delay)return;stop();auto=setInterval(function(){i=(i>=maxIndex())?0:i+1;render()},delay)}
  function stop(){if(auto){clearInterval(auto);auto=null}}
  function stopForever(){delay=0;stop()}

  if(prev)prev.onclick=function(){stopForever();i--;render()};
  if(next)next.onclick=function(){stopForever();i++;render()};

  /* ---- glisare ---- */
  function down(x,y){drag=true;startX=x;startY=y;dx=0;base=pos(i);locked=null;track.style.transition='none';stop()}
  function move(x,y,e){
    if(!drag)return;
    var mx=x-startX,my=y-startY;
    if(locked===null){
      if(Math.abs(mx)<6&&Math.abs(my)<6)return;
      locked=Math.abs(mx)>Math.abs(my)?'x':'y';
    }
    if(locked==='y'){drag=false;apply(pos(i),true);return}
    if(e&&e.cancelable)e.preventDefault();
    dx=mx;
    var max=maxIndex(),p=base+dx;
    /* rezistență la capete */
    if(p>0)p=p*.35;
    var lim=pos(max);
    if(p<lim)p=lim+(p-lim)*.35;
    apply(p,false);
  }
  function up(){
    if(!drag)return;drag=false;
    if(locked!=='x'){apply(pos(i),true);return}
    var s=step(),moved=dx;
    if(Math.abs(moved)>s*.18||Math.abs(moved)>52){
      i+=moved<0?1:-1;   /* exact un card */
    }
    stopForever();
    render();
  }

  view.addEventListener('touchstart',function(e){down(e.touches[0].clientX,e.touches[0].clientY)},{passive:true});
  view.addEventListener('touchmove',function(e){move(e.touches[0].clientX,e.touches[0].clientY,e)},{passive:false});
  view.addEventListener('touchend',up,{passive:true});
  view.addEventListener('touchcancel',up,{passive:true});

  view.addEventListener('mousedown',function(e){
    if(e.button!==0)return;
    down(e.clientX,e.clientY);view.classList.add('is-grabbing');
  });
  window.addEventListener('mousemove',function(e){if(drag)move(e.clientX,e.clientY,e)});
  window.addEventListener('mouseup',function(){view.classList.remove('is-grabbing');up()});
  /* nu deschide produsul dacă a fost o glisare */
  view.addEventListener('click',function(e){if(Math.abs(dx)>8){e.preventDefault();e.stopPropagation()}},true);
  view.addEventListener('dragstart',function(e){e.preventDefault()});

  c.addEventListener('mouseenter',stop);
  c.addEventListener('mouseleave',play);
  c.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){stopForever();i--;render()}
    if(e.key==='ArrowRight'){stopForever();i++;render()}
  });

  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){render(false)},150)});
  render(false);play();
}

/* ---- adaugă în coș din card ---- */
function money(cents){try{return (cents/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' lei'}catch(e){return (cents/100).toFixed(2)+' lei'}}
function refreshCart(){
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
    document.querySelectorAll('.rx-cart__n').forEach(function(e){e.textContent=c.item_count});
    document.querySelectorAll('.rx-cart__t').forEach(function(e){e.textContent=money(c.total_price)});
  }).catch(function(){});
}
function bindAtc(){
  document.querySelectorAll('form[data-rx-atc]').forEach(function(f){
    if(f.dataset.rxBound)return;f.dataset.rxBound='1';
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=f.querySelector('button'),label=f.querySelector('span'),old=label?label.textContent:'';
      if(btn)btn.disabled=true;if(label)label.textContent='Se adaugă…';
      var qi=f.querySelector('input[name="quantity"]');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:f.querySelector('input[name="id"]').value,quantity:qi?parseInt(qi.value||'1',10):1})})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){f.classList.add('is-done');if(label)label.textContent='Adaugat ✓';refreshCart();
        setTimeout(function(){f.classList.remove('is-done');if(label)label.textContent=old;if(btn)btn.disabled=false},1800)})
      .catch(function(){if(label)label.textContent='Eroare';setTimeout(function(){if(label)label.textContent=old;if(btn)btn.disabled=false},1800)});
    });
  });
}
window.rxBindAtc=bindAtc;
function boot(){document.querySelectorAll('.rx-carousel').forEach(init);bindAtc()}
if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
document.addEventListener('shopify:section:load',boot);
document.addEventListener('rx:products-added',bindAtc);
})();